import React, { useEffect, useState } from "react";
import useHttp from "../../../hook/use-http";
import { Chart } from "react-google-charts";
import ChartLoader_Jupiter from "./ChartLoader_Jupiter";
import NoData_Jupiter from "./NoData_Jupiter";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PieChartSocErc_Jupiter({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const buckets = data?.groupby?.buckets ?? [];

    // Default zero values
    let high = 0, mid = 0, low = 0;

    if (buckets.length > 0) {
      const regen = buckets[0];

      high = regen?.high_regen_mode_percent?.values?.["50.0"];
      mid = regen?.mid_regen_mode_percent?.values?.["50.0"];
      low = regen?.low_regen_mode_percent?.values?.["50.0"];

      // If values are invalid (like -1), treat them as 0
      high = high >= 0 ? high : 0;
      mid = mid >= 0 ? mid : 0;
      low = low >= 0 ? low : 0;
    }

    const result = [
      ["Regen Mode", "Percent"],
      ["High Regen", high],
      ["Mid Regen", mid],
      ["Low Regen", low],
    ];

    setChartData(result);
  };
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  const loggedInUser = useSelector(selectLoggedInUser);

  const options = {
    title: "Regen Mode Distribution",
    pieHole: 0.4, // donut style
    legend: {
      position: "right",
      textStyle: { fontSize: 12 },
    },
    pieSliceText: "percentage", // shows percentage on slice
    pieSliceTextStyle: {
      color: "black",
      fontSize: 12,
    },
    slices: {
      0: { color: "#A6CEE3" }, // High Regen - Blue
      1: { color: "#1F78B4" }, // Mid Regen - Orange
      2: { color: "#A6CEE3" }, // Low Regen - Green
    },
    chartArea: { width: "90%", height: "80%" },
  };

  return (
    <div className="v-title chartbox drive_graph p-0">
      <div
        className={
          !(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
            ? "titlebg titlebd_drive pb-2 pt-2"
            : "titlebg titlebd_drive box_title pb-2 pt-2"
        }
      >
        {title}
      </div>
      <div className="chartHGT">
        {isLoading ? (
          <ChartLoader_Jupiter />
        ) : chartdata.length === 0 ? (
          <NoData_Jupiter />
        ) : (
          <Chart
            chartType="PieChart"
            width="100%"
            height="247px"
            data={chartdata}
            options={options}
          />
        )}
      </div>
    </div>
  );
}

export default PieChartSocErc_Jupiter;
